import { PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import {
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIllustration,
    Heading,
    ProgressiveImage,
} from '@gitbook/spine-react';

import { useInsertPageCommands } from '../Page';
import emptyImageDarkSrc from './images/empty-dark.svg';
import emptyImageLightSrc from './images/empty-light.svg';

/**
 * Empty state for the pages table of contents.
 */
export function PagesToCEmptyState(props: { readOnly: boolean }) {
    const { readOnly } = props;

    const [paletteElement, palette] = useInsertPageCommands();

    return (
        <>
            {paletteElement}
            <EmptyState>
                <EmptyStateIllustration>
                    <ProgressiveImage
                        width={64}
                        height={64}
                        src={{
                            light: emptyImageLightSrc,
                            dark: emptyImageDarkSrc,
                        }}
                    />
                </EmptyStateIllustration>
                {readOnly ? (
                    <>
                        <Heading>No pages</Heading>
                        <Description>No pages have been created yet.</Description>
                    </>
                ) : (
                    <>
                        <Description>
                            Create your first pages to write your documentation.
                        </Description>
                        <EmptyStateActions>
                            <PaletteButton
                                kind="secondary"
                                leadingIcon={Icon.Plus}
                                label="Create a first page"
                                palette={() => palette}
                            />
                        </EmptyStateActions>
                    </>
                )}
            </EmptyState>
        </>
    );
}
